// frontend/src/components/SkipToContent.js

import React from 'react';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const SkipLink = styled(Button)(({ theme }) => ({
  position: 'fixed',
  top: -100,
  left: theme.spacing(2),
  zIndex: 2000,
  padding: theme.spacing(1, 2),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  borderRadius: theme.shape.borderRadius,
  textDecoration: 'none',
  '&:focus': {
    top: theme.spacing(2),
    outline: `3px solid ${theme.palette.primary.dark}`,
    outlineOffset: 2,
  },
  transition: 'top 0.2s ease-in-out',
}));

const SkipToContent = () => {
  const handleSkip = (e) => {
    e.preventDefault();
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <SkipLink
        href="#main-content"
        onClick={handleSkip}
        tabIndex={0}
        aria-label="Skip to main content"
      >
        Skip to main content
      </SkipLink>
      <SkipLink
        href="#navigation"
        onClick={(e) => {
          e.preventDefault();
          const nav = document.getElementById('navigation');
          if (nav) {
            nav.focus();
            nav.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        tabIndex={0}
        aria-label="Skip to navigation"
        sx={{ left: 180 }}
      >
        Skip to navigation
      </SkipLink>
    </>
  );
};

export default SkipToContent;